import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReferralReasonTab from "./ReferralReasonTab";
import {makeError} from "../../../components/modals/ErrorModal";
import SvGraphics from "../../../assets/SvGraphics";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import VisitSummaryFirstBlock from "../../../components/PatientOnboard/VisitSummaryFirstBlock";



class DeclarationsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkboxes: this.props.checkboxes,
            entry: this.props.entry,

        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    async showNotification(code, value) {
        let {t}=this.props
        let {entry}=this.state
        this.props.onYesNoValueChange(code, value)
        if(entry[code]==="Yes"){
            let message= code==="Medical_institute_road_safety"?t('patient_boarding.Notify_medical_institute'):t('patient_boarding.Notify_ministry_affairs')
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
            }, [message]);
        }
    }
    render() {

        let {entry} = this.state
        let {t}=this.props

        return (


            <div className={'patientForm-box-container'}>
                <div className={'patientsFormBoxes-title-text'}>
                    <label className={'patientsFormBoxes-title-text-label'}>
                        {t('patient_boarding.declarations')}
                    </label>
                </div>

                    <div className={'patientsFormBoxes'}>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.use_cannabis_risk')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration1')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration2')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration3')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration5')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration6')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration7')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration8')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration9')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration10')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration12')}</label>
                    </div>
                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration11')}</label>
                    </div>

                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration13')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration14')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration15')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration16')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration17')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration18')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration19')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration20')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration21')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration22')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration23')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration24')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration25')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration26')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclaration27')}</label>
                    </div>
                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.instruction_info')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingInstruction1')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingInstruction2')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingInstruction3')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingInstruction4')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingInstruction5')}</label>
                    </div>

                    <div className={'blankSpace'}/>
                    {/*<div className={'patientsFormRow-declarations'}>*/}
                    {/*    <label className={'infoLabel-declerations'}>{t('patient_boarding.ApprovingDeclarationEnd')}</label>*/}
                    {/*</div>*/}
                    <div className={'blankSpace'}/>

                    <div className={'checkbox-label'}>
                        <input type={"checkbox"} className={"checkboxStyle"} name={'DeclarationAcceptApprovingClinic'} checked={entry.DeclarationAcceptApprovingClinic}
                               onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                        <label className={'infoLabel'} style={{color:'#000000'}}>{t('patient_boarding.DeclarationAcceptDoctor')}</label>
                    </div>

                </div>
            </div>

        )
    }
}



const DeclarationsTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(DeclarationsTabComposed);

export default DeclarationsTab;

